export const getOcplcConfiguration = `query ParameterConfiguration($filter: ParameterConfigurationRequest!) {
  parameterConfiguration(filter: $filter) {
    parameterConfiguration {
      pkId
      version
      region
      productFamily
      productGroup
      parameterKey
      parameterValue
      parameterText
      comments
      status
      createdBy
      whoChanged
      lastModifiedDate
    }
  }
}`;

export const saveOcplcConfiguration = `mutation UpdateParameterConfiguration($input: ParameterConfigurationUpdateRequest!) {
  updateParameterConfiguration(input: $input) {
    response
    message
  }
}`;